/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Directive, ElementRef, Renderer2 } from "@angular/core";
import { STRICT_WIDTH_CLASS } from "./constants";
import { DatagridRenderOrganizer } from "./render-organizer";
var DatagridCellRenderer = (function () {
    function DatagridCellRenderer(el, renderer, organizer) {
        var _this = this;
        this.el = el;
        this.renderer = renderer;
        this.subscription = organizer.clearWidths.subscribe(function () { return _this.clearWidth(); });
    }
    DatagridCellRenderer.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    DatagridCellRenderer.prototype.clearWidth = function () {
        this.renderer.removeClass(this.el.nativeElement, STRICT_WIDTH_CLASS);
        this.renderer.setStyle(this.el.nativeElement, "width", null);
    };
    DatagridCellRenderer.prototype.setWidth = function (strict, value) {
        if (strict) {
            this.renderer.addClass(this.el.nativeElement, STRICT_WIDTH_CLASS);
        }
        else {
            this.renderer.removeClass(this.el.nativeElement, STRICT_WIDTH_CLASS);
        }
        this.renderer.setStyle(this.el.nativeElement, "width", value + "px");
    };
    return DatagridCellRenderer;
}());
export { DatagridCellRenderer };
DatagridCellRenderer.decorators = [
    { type: Directive, args: [{
                selector: "clr-dg-cell"
            },] },
];
/** @nocollapse */
DatagridCellRenderer.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: DatagridRenderOrganizer, },
]; };
//# sourceMappingURL=cell-renderer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/render/cell-renderer.js
// module id = 166
// module chunks = 4